// OS CREDORES (BANCOS E CONSIGNATÁRIAS) QUE UMA TELA OPERACIONAL PODE ESCOLHER.
//
// Par de `unidades-operaveis.ts`, pelo mesmo motivo: o credor de teste
// (`bancos.tenant_de_teste`) sai das contagens sempre e da LISTAGEM por padrão,
// mas convênio, rubrica, bate-carteira, benefício, vitrine e token de API
// precisam alcançá-lo — senão o banco de teste existe e não se usa, que foi
// exatamente o defeito do PR 105 com a organização de teste.
//
// "Não conta nos números" é sobre CONTAR, não sobre operar.

import type { AdminBanco } from "@atlas/sdk";
import { atlas } from "./sdk";

/** Prefixo `["admin", "bancos"]` de propósito: quem invalida a listagem depois
 *  de salvar um banco invalida este recorte junto. */
export const QUERY_CREDORES_OPERAVEIS = ["admin", "bancos", "operaveis"] as const;

export function listarCredoresOperaveis() {
  return atlas.admin.listBancos({ incluirTeste: "1" });
}

/** O nome, e `(teste)` quando for credor de teste. */
export function rotuloCredor(b: Pick<AdminBanco, "nome" | "tenantDeTeste">): string {
  return `${b.nome}${b.tenantDeTeste ? " (teste)" : ""}`;
}
